import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translations.json';
import translationFR from "./locales/fr/translations.json";
import translationDE from "./locales/de/translations.json";
import translationNL from "./locales/nl/translations.json";
import translationES from "./locales/es/translations.json";
import translationIT from "./locales/it/translations.json";
import translationPT from "./locales/pt/translations.json";
import translationPL from "./locales/pl/translations.json";

const resources = {
  en: { translation: translationEN },
  fr: { translation: translationFR },
  de: { translation: translationDE },
  nl: { translation: translationNL },
  es: { translation: translationES },
  it: { translation: translationIT },
  pt: { translation: translationPT },
  pl: { translation: translationPL }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: true,
    detection: {
      order: ['queryString', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie']
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
